import React, { useState, useEffect, memo } from "react";
import { connect } from "react-redux";
import Paginated from "./Paginated";
import { Link, useLocation } from "react-router-dom";
import { importIcon } from "../../../../Image/Index";
import TransactionViewModal from "../Transactions/TransactionViewModal";
import { getRedemption, clearRedemption } from "../../../../actions/redemption";
import {
  getAllRedemption,

} from "../../../../components/pages/campaigns/services";
import { ValidatorForm } from "react-form-validator-core";
import SelectValidator from "../../partial/SelectValidator";
import {
  getAllTrasaction,
  getRedeemDatas,
  fulfilmentTokenApi,
  getAllOrderStatus,
} from "../../../../actions/auth";
import { decrypt, encrypt } from "../../../../utils/encodingdecoding";
import {
  CLIENT_ID,
  SECRET_KEY,
  edsringMerchantId,
  movodreamMerchantId,
  movodreamStagingMerchantId,
  sobiscoMerchantId,
  starblazeMerchantId,

} from "../../../../utils";
import { COLUMNS, SOBISCO_COLUMNS } from "./column";
import { getDisplayDate } from "../../../../utils/helper";
import Header from "../../layout/Header";
import { MOVO_COLUMNS, MOVO_VOUCHER_COLUMNS } from "./movodreamColumn";
import { FULFIL_CLIENT_ID_SOBISCO, FULFIL_SECRET_KEY_SOBISCO } from "../../../../utils/url";

// order_status code -> label (sobisco fulfilment)
const ORDER_STATUS_LABELS = {
  0: "Refunded",
  1: "Success",
  2: "Failed",
  3: "Order Placed",
  4: "Order Confirmed",
  5: "Dispatched",
  6: "Delivered",
  7: "Returned",
  8: "Cancelled",
  9: "Partially Completed",
  10: "Pending",
};

const getOrderStatusLabel = (status) =>
  status === undefined || status === null || status === ""
    ? "-"
    : ORDER_STATUS_LABELS[Number(status)] ?? status;

const RedemptionList = memo(
  ({ getRedemption, Redemption, clearRedemption }) => {
    const location = useLocation();
    const [data, setData] = useState([]);
    const [voucherData, setVoucherData] = useState([]);
    const [voucherResponse, setVoucherResponse] = useState([]);
    const [transactionCount, setTransactionCount] = useState();
    const [loader, setLoader] = useState(true);
    const [showLogin, setShowLogin] = useState(false);
    const [transactionId, setTransactionId] = useState("");
    const [activeTab, setActiveTab] = useState("point"); // "point" | "voucher"
    const [orderStatusMap, setOrderStatusMap] = useState({}); // ordercode -> order_status (sobisco)

    let id = decrypt(localStorage.getItem("Id"));

    const isChannelPartner = location.pathname.includes("channel-partner");
    const isSobisco = isChannelPartner && id === sobiscoMerchantId;
    const merchantcode = decrypt(localStorage.getItem("merchantcode"));
    const isMovodream =
      merchantcode === movodreamMerchantId || merchantcode === starblazeMerchantId ||
      merchantcode === movodreamStagingMerchantId;

    // ---- initial load: loader band tabhi hoga jab saari APIs complete ho jayein ----
    useEffect(() => {
      const calls = [];
      let tempPageIndex = JSON.parse(localStorage.getItem("TransPageIndex"));
      if (tempPageIndex === 1) {
        calls.push(fetch());
      }
      // voucher data (only for movodream, non channel-partner)
      if (!isChannelPartner && isMovodream) {
        calls.push(fetchVoucherData());
      }
      // order status (only for sobisco)
      if (isSobisco) {
        calls.push(fetchOrderStatus());
      }
      if (calls.length) {
        setLoader(true);
        Promise.allSettled(calls).finally(() => setLoader(false));
      }
      // eslint-disable-next-line
    }, []);

    const fetchVoucherData = async () => {
      try {
        const token = JSON.parse(localStorage.getItem("token_gen"));
        const res = await getRedeemDatas(token?.access_token);
        setVoucherResponse(res?.data || []);
      } catch (err) {
        console.error(err);
      }
    };

    // ---- fetch order status (only for sobisco): token generate -> getallOrderStatus ----
    const fetchOrderStatus = async () => {
      try {
        const tokenRes = await fulfilmentTokenApi({
          client_id: encrypt(FULFIL_CLIENT_ID_SOBISCO),
          secret_key: encrypt(FULFIL_SECRET_KEY_SOBISCO),
        });
        const accessToken =
          tokenRes?.message?.data?.access_token || tokenRes?.data?.access_token;
        if (!accessToken) return;

        const res = await getAllOrderStatus(accessToken);
        console.log(res)
        const list = Array.isArray(res?.data) ? res.data : [];

        // response: data[].code (order code) -> data[].order_status
        const map = {};
        list.forEach((item) => {
          if (item?.code) map[item.code] = item?.order_status;
        });
        setOrderStatusMap(map);
      } catch (err) {
        console.error(err);
      }
    };

    // map voucher response -> table rows (only redeemed vouchers)
    useEffect(() => {
      if (voucherResponse && voucherResponse.length) {
        const mapped = voucherResponse
          .filter((item) => item?.redeemVoucher?.VoucherUsed === true) // sirf redeemed
          .map((item) => {
            const customer = item?.customer;
            const redeem = item?.redeemVoucher;
            const fullName =
              [customer?.firstname, customer?.lastName]
                .filter(Boolean)
                .join(" ") ;

            return {
              name: fullName,
              mobile: customer?.mobile ,
              customerCode: (
                <Link
                  to={
                    location.pathname.includes("channel-partner")
                      ? `/channel-partner/user-view/${customer?.customercode}`
                      : `/customer-view/${customer?.customercode}`
                  }
                >
                  {customer?.customercode}
                </Link>
              ),
              vouchercode: redeem?.voucherCode,
              voucherName: redeem?.voucherTemplateCode,
              value: redeem?.earnedValue,
              expiredate: getDisplayDate(redeem?.expiryDate),
            };
          });
        setVoucherData(mapped.reverse());
      } else {
        setVoucherData([]);
      }
    }, [voucherResponse]);

    useEffect(() => {
      const ShortData = async () => {
        let tempData = Redemption?.data?.data;
        if (tempData) {
          (await tempData) &&
            (tempData = tempData?.map((val) => ({
              name: val?.customer?.name,
              firstname:   val?.customer?.name || val?.customer?.firstname,
              point: val?.transactionDetail?.values,
              voucher: val?.transactionDetail?.voucherCode,
              mobile: val?.customer?.mobile,
              ordercode: val.transactionDetail?.ordercode,
              order_status: getOrderStatusLabel(
                orderStatusMap[val.transactionDetail?.ordercode],
              ),
              ordervalue: val.transactionDetail?.ordervalue,
              redemption_type:
                val.transactionDetail?.redemption_type
                  ?.split("_")[0]
                  ?.charAt(0)
                  .toUpperCase() +
                val.transactionDetail?.redemption_type?.split("_")[0]?.slice(1),
              title: val.transactionDetail?.itemlist
                ?.map((item) => item.title)
                .join(", "),
              transactionDate: getDisplayDate(
                val?.transactionDetail?.transactionDate,
              ),
              transactionProcessedDate: val?.transactionDetail?.transactionDate,
              action: (
                <Link
                  to={
                    location.pathname.includes("channel-partner")
                      ? `/channel-partner/user-view/${val?.customer?.customercode}`
                      : `/customer-view/${val?.customer?.customercode}`
                  }
                >
                  <i className="fa-solid fa-eye"></i> View Details
                </Link>
              ),
            })));

          if (tempData) {
            await tempData.sort(function (a, b) {
              if (a.transactionProcessedDate === null) {
                return 1;
              } else if (b.transactionProcessedDate === null) {
                return -1;
              }
              const dateA = new Date(a.transactionProcessedDate);
              const dateB = new Date(b.transactionProcessedDate);
              if (dateA < dateB) {
                return 1;
              } else if (dateA > dateB) {
                return -1;
              } else {
                const timeA = dateA.getTime();
                const timeB = dateB.getTime();
                return timeB - timeA;
              }
            });
          }
          setData(tempData);
        }
      };

      ShortData();
    }, [Redemption, orderStatusMap]);

    const handleViewModal = (data) => {
      setShowLogin(true);
      setTransactionId(data);
    };

    const fetch = async () => {
      try {
        const token = JSON.parse(localStorage.getItem("token_gen"));
        await getRedemption(token?.access_token, 1, 50);
      } catch (err) {
        console.error(err);
      }
    };

    // ---- CSV for channel-partner (unchanged) ----
    const generateCSV = async () => {
      setLoader(true);
      try {
        const token = JSON.parse(localStorage.getItem("token_gen"));
        const idLocal = localStorage.getItem("Id");

        if (!token?.access_token || !idLocal) {
          throw new Error("Missing token or ID");
        }
        await getAllRedemption(token.access_token, "", "");
        const transactions = Redemption?.data?.data || [];
        const transformedData = transactions?.map((val) => ({
          name: val.customer?.name || val?.customer?.firstname,
          mobile: val.customer?.mobile,
          ordercode: val.transactionDetail?.ordercode,
          ordervalue: val.transactionDetail?.ordervalue,
          redemption_type:
            val.transactionDetail?.redemption_type
              ?.split("_")[0]
              ?.charAt(0)
              .toUpperCase() +
            val.transactionDetail?.redemption_type?.split("_")[0]?.slice(1),
          title: val.transactionDetail?.itemlist
            ?.map((item) => item.title)
            .join(", "),
          transactionDate: getDisplayDate(val?.transactionDetail?.transactionDate),
          order_status: getOrderStatusLabel(
            orderStatusMap[val.transactionDetail?.ordercode],
          ),
        }));
        downloadRedemptionCSV(transformedData?.reverse(), isSobisco);
      } catch (error) {
        console.error("Error generating CSV:", error.message || error);
      } finally {
        setLoader(false);
      }
    };

    const downloadRedemptionCSV = (rows, includeOrderStatus = false) => {
      const csvHeaders = [
        "Name",
        "Mobile",
        "Order",
        "Order Code",
        "Order Value",
        "Title",
        "Date",
        ...(includeOrderStatus ? ["Order Status"] : []),
      ];
      const csvData = [
        csvHeaders,
        ...rows.map((row) => [
          row.name,
          row.mobile,
          row.redemption_type,
          row.ordercode,
          row.ordervalue,
          row.title,
          row.transactionDate,
          ...(includeOrderStatus ? [row.order_status] : []),
        ]),
      ];
      const csvContent =
        "data:text/csv;charset=utf-8," +
        csvData.map((row) => row.join(",")).join("\n");
      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "report.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    // ---- CSV for Point tab (movodream) ----
    const generatePointCSV = () => {
      if (!data || data.length === 0) return;
      const rows = data.map((row) => ({
        name: row.name || row.firstname,
        mobile: row.mobile,
        redemption_type: row.redemption_type,
        ordercode: row.ordercode,
        ordervalue: row.ordervalue,
        title: row.title,
        transactionDate: row.transactionDate,
      }));
      downloadRedemptionCSV(rows);
    };

    // ---- CSV for Voucher tab (movodream) ----
    const generateVoucherCSV = () => {
      if (!voucherData || voucherData.length === 0) return;
      const headers = [
        "Name",
        "Mobile",
        "Voucher Code",
        "Voucher Name",
        "Value",
        "Expiry Date",
        "Status",
      ];
      const rows = voucherData.map((item) => [
        item.name,
        item.mobile,
        item.vouchercode,
        item.voucherName,
        item.value,
        item.expiredate,
        "Redeemed",
      ]);
      const csvContent = [headers, ...rows]
        .map((row) => row.map((val) => `"${val}"`).join(","))
        .join("\n");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "voucher_list.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    const handleMovodreamDownload = () => {
      if (activeTab === "point") {
        generatePointCSV();
      } else {
        generateVoucherCSV();
      }
    };

    useEffect(() => {
      setTransactionCount(Redemption?.data?.totalCount);
    }, [Redemption]);

    return (
      <>
        <Header name={"Redemption"} />
        {loader && (
          <div className="mainPreloaderMain">
            <div className="mainPreloader">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        )}
        <div className="dashboard__content">
          <div className="container-fluid">
            <div className="dashboard__transactionsCard">
              <div className="dashboard__header">
                <div className="dashboard__left">
                  <h4 id="transction_list">All Redemptions</h4>
                </div>
                {isChannelPartner && (
                  <div className="dashboard__right">
                    <button onClick={generateCSV} className="btn btn-default">
                      <i
                        class="fa-solid fa-download"
                        style={{ marginRight: "10px" }}
                      ></i>
                      Download Redemption
                    </button>
                  </div>
                )}
                {!isChannelPartner && isMovodream && (
                  <div className="dashboard__right">
                    <button
                      onClick={handleMovodreamDownload}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        padding: "10px 20px",
                        borderRadius: "8px",
                        border: "1px solid #4a3aff",
                        background: "#fff",
                        color: "#4a3aff",
                        fontWeight: "600",
                        fontSize: "14px",
                        cursor: "pointer",
                        transition: "all 0.2s ease-in-out",
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.background = "#4a3aff";
                        e.currentTarget.style.color = "#fff";
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.background = "#fff";
                        e.currentTarget.style.color = "#4a3aff";
                      }}
                    >
                      <i class="fa-solid fa-download"></i>
                      Download {activeTab === "point" ? "Point" : "Voucher"}
                    </button>
                  </div>
                )}
              </div>

              {/* Tabs — only for movodream, non channel-partner */}
              {!isChannelPartner && isMovodream && (
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    padding: "16px 20px",
                    background: "#f8f9fb",
                    borderBottom: "1px solid #ececec",
                  }}
                >
                  <button
                    onClick={() => setActiveTab("point")}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      padding: "9px 20px",
                      borderRadius: "24px",
                      border:
                        activeTab === "point"
                          ? "1px solid #4a3aff"
                          : "1px solid #e0e0e0",
                      background: activeTab === "point" ? "#4a3aff" : "#ffffff",
                      color: activeTab === "point" ? "#ffffff" : "#6c6c6c",
                      fontWeight: "600",
                      fontSize: "14px",
                      cursor: "pointer",
                      boxShadow:
                        activeTab === "point"
                          ? "0 3px 8px rgba(74,58,255,0.25)"
                          : "none",
                      transition: "all 0.2s ease-in-out",
                      outline: "none",
                    }}
                  >
                    <i class="fa-solid fa-coins"></i>
                    Point
                  </button>
                  <button
                    onClick={() => setActiveTab("voucher")}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      padding: "9px 20px",
                      borderRadius: "24px",
                      border:
                        activeTab === "voucher"
                          ? "1px solid #4a3aff"
                          : "1px solid #e0e0e0",
                      background:
                        activeTab === "voucher" ? "#4a3aff" : "#ffffff",
                      color: activeTab === "voucher" ? "#ffffff" : "#6c6c6c",
                      fontWeight: "600",
                      fontSize: "14px",
                      cursor: "pointer",
                      boxShadow:
                        activeTab === "voucher"
                          ? "0 3px 8px rgba(74,58,255,0.25)"
                          : "none",
                      transition: "all 0.2s ease-in-out",
                      outline: "none",
                    }}
                  >
                    <i class="fa-solid fa-ticket"></i>
                    Voucher
                  </button>
                </div>
              )}

              <div className="dashboard__body">
                <Paginated
                  data={
                    isChannelPartner
                      ? data
                      : isMovodream
                        ? activeTab === "point"
                          ? data
                          : voucherData
                        : data
                  }
                  columns={
                    isChannelPartner
                      ? isSobisco
                        ? SOBISCO_COLUMNS
                        : COLUMNS
                      : isMovodream
                        ? activeTab === "point"
                          ? MOVO_COLUMNS
                          : MOVO_VOUCHER_COLUMNS
                        : MOVO_COLUMNS
                  }
                  serverPaginated={!(isMovodream && activeTab === "voucher")}
                  setLoader={setLoader}
                  loader={loader}
                />
              </div>
            </div>
            {showLogin && (
              <TransactionViewModal
                show={showLogin}
                close={() => setShowLogin(false)}
                transactionId={transactionId}
              />
            )}
          </div>
        </div>
      </>
    );
  },
);

const mapStateToProps = (state) => ({
  Redemption: state.Redemption,
});
const mapDispatchToProps = {
  getRedemption,
  clearRedemption,
};

export default connect(mapStateToProps, mapDispatchToProps)(RedemptionList);